import type { GraphItemsModel } from './types';

/**
 * Generic function to get all added and updated items from a GraphItemsModel.
 */
export const getAddedAndUpdatedItems = <M extends GraphItemsModel<any>>(
  graphItems: M
): M extends GraphItemsModel<infer T> ? T[] : never => {
  const { add, update, byId } = graphItems;
  return [...add, ...update].map(id => byId.get(id)!) as any;
};
